export default {
    name: 'WeekdayHeader',
    props: ['title']
}